import { render, staticRenderFns } from "./text-type-1.vue?vue&type=template&id=d3f96cd0&scoped=true&"
import script from "./text-type-1.vue?vue&type=script&lang=js&"
export * from "./text-type-1.vue?vue&type=script&lang=js&"
import style0 from "./text-type-1.vue?vue&type=style&index=0&id=d3f96cd0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3f96cd0",
  null
  
)

export default component.exports